// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2ZVPl","footer":"ReportModalFilter_footer__X422Q"};